import React from 'react'
import moment from 'moment-timezone'

import CalendarEventChip from './CalendarEventChip'
import { groupByDay } from './calendarHelpers'

import css from './style.scss'

/**
 * Phone fallback for the month grid. Same month, same filter, same navigation —
 * just a day-grouped list, because seven columns are unreadable on a phone.
 * Empty days are omitted entirely.
 */
const CalendarAgendaView = ({ month, events }) => {
  const grouped = groupByDay(events)
  const days = Object.keys(grouped)
    .filter(key => moment(key, 'YYYY-MM-DD').isSame(moment(month), 'month'))
    .sort()

  if (!days.length) {
    return (
      <p className={css.agendaEmpty}>
        Nothing scheduled in {moment(month).format('MMMM YYYY')}.
      </p>
    )
  }

  return (
    <div className={css.agenda}>
      {days.map(key => (
        <div key={key} className={css.agendaDay}>
          <h4 className={css.agendaDayHeading}>
            <time dateTime={key}>{moment(key, 'YYYY-MM-DD').format('ddd, MMM D')}</time>
          </h4>
          <ul className={css.chipList}>
            {grouped[key].map(event => (
              <CalendarEventChip key={`${event.type}-${event.id}`} event={event} />
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}

CalendarAgendaView.propTypes = {
  month: React.PropTypes.object.isRequired,
  events: React.PropTypes.array.isRequired
}

export default CalendarAgendaView
